import styled from "@emotion/native";

export const Container = styled.View({
	width: 120,
	height: 120,
	borderWidth: 10,
	borderRadius: 60,
	borderColor: "#C5E2E3",
	justifyContent: "center",
	alignItems: "center",
});

export const RightOuterRing = styled.View({
	width: 120,
	height: 120,
	borderWidth: 10,
	borderRadius: 60,
	position: "absolute",
	borderLeftColor: "transparent",
	borderBottomColor: "transparent",
	borderRightColor: "#58C4C6",
	borderTopColor: "#58C4C6",
	transform: [{ rotateZ: "-135deg" }],
});

export const OffsetRing = styled.View({
	width: 120,
	height: 120,
	position: "absolute",
	borderWidth: 10,
	borderRadius: 60,
	borderLeftColor: "transparent",
	borderBottomColor: "transparent",
	borderRightColor: "#58C4C6",
	borderTopColor: "#58C4C6",
	transform: [{ rotateZ: "45deg" }],
});

export const LeftOuterRing = styled.View({
	width: 120,
	height: 120,
	position: "absolute",
	borderWidth: 10,
	borderRadius: 60,
	borderLeftColor: "transparent",
	borderBottomColor: "transparent",
	borderRightColor: "#C5E2E3",
	borderTopColor: "#C5E2E3",
	transform: [{ rotateZ: "-135deg" }],
});
